export default __webpack_public_path__ + "media/icons/info-78461465.svg";